module.exports = __webpack_public_path__ + "static/media/settings.c07425ee.svg";